var _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _path3, _path4, _path5, _path6, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect6, _path21, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 216,
    viewBox: "0 0 264 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.8901,
    y: 36.9496,
    width: 198.856,
    height: 159.219,
    fill: "#F2E6C9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7012,
    y: 65.8374,
    width: 89.3506,
    height: 101.443,
    fill: "#F5F9F1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0601,
    y: 81.2891,
    width: 82.6325,
    height: 81.2889,
    fill: "#AAD5D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8496 162.402V164.055L136.803 164.068V162.375L53.8496 162.402Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4312 185.899V206.473H235.902V185.899H27.4312Z",
    fill: "#11BB8D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 157.519,
    y: 81.2891,
    width: 62.4782,
    height: 124.956,
    fill: "#F5F9F1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 165.58,
    y: 81.2891,
    width: 47.0266,
    height: 120.926,
    fill: "#AAD5D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.316 134.138V142.419H160.762V134.138H216.316Z",
    fill: "#F5E6C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.466 137.497V139.06H165.381V137.497H181.466Z",
    fill: "#FEFEF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19873 206.043V214.86H259.801V206.043H4.19873Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 212.762V215.281H264V212.762H0Z",
    fill: "#79747E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1494 73.323V89.3518C22.1494 89.3518 22.3564 103.693 40.0559 103.693C57.7553 103.693 57.7553 89.3518 57.7553 89.3518V73.323H22.1494Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.1597 72.9343V89.0436C56.1597 89.0436 56.2638 103.457 71.7473 103.457C87.2308 103.457 87.2308 89.0436 87.2308 89.0436V72.9343H56.1597Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.461 73.4146V89.651C117.461 89.651 117.461 104.178 101.926 104.178C86.3901 104.178 86.3901 89.651 86.3901 89.651V73.4146H117.461Z",
    fill: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.202 73.4962V89.918C116.202 89.918 116.333 104.611 131.908 104.611C147.483 104.611 147.483 89.918 147.483 89.918V73.4962H116.202Z",
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.504 73.5969V90.247C177.504 90.247 177.504 105.144 162.074 105.144C146.643 105.144 146.643 90.247 146.643 90.247V73.5969H177.504Z",
    fill: "black"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.666 73.6906V90.5533C176.666 90.5533 176.77 105.641 192.253 105.641C207.737 105.641 207.737 90.5533 207.737 90.5533V73.6906H176.666Z",
    fill: "black"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.678 73.7594V90.7786C243.678 90.7786 243.799 106.006 225.348 106.006C206.896 106.006 206.896 90.7786 206.896 90.7786V73.7594H243.678Z",
    fill: "black"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4541 66.1523V82.1812C18.4541 82.1812 18.6611 96.5227 36.3606 96.5227C54.0602 96.5227 54.0602 82.1812 54.0602 82.1812V66.1523H18.4541Z",
    fill: "#11BB8D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0601 66.1516V82.2609C54.0601 82.2609 54.1642 96.6745 69.6477 96.6745C85.1312 96.6745 85.1312 82.2609 85.1312 82.2609V66.1516H54.0601Z",
    fill: "#DFE2EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.202 66.1509V82.3873C116.202 82.3873 116.202 96.9146 100.666 96.9146C85.1304 96.9146 85.1304 82.3873 85.1304 82.3873V66.1509H116.202Z",
    fill: "#11BB8D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.202 66.1497V82.5714C116.202 82.5714 116.333 97.2646 131.908 97.2646C147.483 97.2646 147.483 82.5714 147.483 82.5714V66.1497H116.202Z",
    fill: "#DFE2EB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M178.344 66.1479V82.798C178.344 82.798 178.344 97.6955 162.914 97.6955C147.483 97.6955 147.483 82.798 147.483 82.798V66.1479H178.344Z",
    fill: "#11BB8D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M178.345 66.1465V83.0092C178.345 83.0092 178.449 98.0969 193.932 98.0969C209.416 98.0969 209.416 83.0092 209.416 83.0092V66.1465H178.345Z",
    fill: "#DFE2EB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M247.541 66.1455V83.1648C247.541 83.1648 247.662 98.3925 229.211 98.3925C210.76 98.3925 210.76 83.1648 210.76 83.1648V66.1455H247.541Z",
    fill: "#11BB8D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3361 12.9329H40.3955L18.4541 66.5197H52.9086L68.3361 12.9329Z",
    fill: "#11BB8D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.126 12.9329H93.5288L85.1312 66.5197H53.9551L68.126 12.9329Z",
    fill: "#FEFEF4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.141 12.9329H93.318L84.9204 66.5197H116.306L119.141 12.9329Z",
    fill: "#11BB8D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M118.932 12.9329H144.65L147.642 66.5197H116.098L118.932 12.9329Z",
    fill: "#FEFEF4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M170.208 12.9329H144.438L147.431 66.5197H178.502L170.208 12.9329Z",
    fill: "#11BB8D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M170 12.9329H195.612L209.521 66.5197H178.293L170 12.9329Z",
    fill: "#FEFEF4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M224.738 12.9325H195.402L211.139 66.5194H247.541L224.738 12.9325Z",
    fill: "#11BB8D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4541,
    y: 64.4937,
    width: 229.087,
    height: 4.03085,
    fill: "#F5F9F1",
    fillOpacity: 0.3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5713 6.6344V12.9326H223.219V6.6344H40.5713Z",
    fill: "#F5E6C6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M225.372 0V12.9524H40.624V0H225.372Z",
    fill: "#11BB8D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M225.372 12.0327V13.043H40.624V12.0327H225.372Z",
    fill: "#11BB8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyGraphic);
export default __webpack_public_path__ + "static/media/CompanyGraphic.55d14d719892c02df6966b09ed74aa29.svg";
export { ForwardRef as ReactComponent };